export async function retryOnFailure(action, errorHandler = null, timeout = 100, maxRetries = 100) {
  if (maxRetries == 0) return;

  try {
    await action();
  } catch (e) {
    if (typeof errorHandler === 'function') {
      errorHandler(e, maxRetries);
    }
    await new Promise(resolve => setTimeout(resolve, timeout))
    return retryOnFailure(action, errorHandler, timeout, maxRetries - 1)
  }
}
